var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-body" },
    [
      _vm.showDownload
        ? _c(
            "v-layout",
            { attrs: { "justify-space-between": "" } },
            [
              _c("v-spacer", [
                _vm.showBodyInfo
                  ? _c("div", { staticClass: "body-info" }, [
                      _c("img", {
                        attrs: { src: require("@/assets/info.svg") },
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "body-info-text" }, [
                        _vm._v(
                          "Os dados deste relatório são atualizados em até 2 dias desde que não haja interrupção na integração entre os sistemas."
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              !_vm.$isMobile()
                ? _c(
                    "v-btn",
                    { attrs: { flat: "" }, on: { click: _vm.onDownload } },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("get_app"),
                      ]),
                      _vm._v("\n      Download\n    "),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showExport
        ? _c(
            "v-layout",
            { attrs: { "justify-space-between": "" } },
            [
              _c("v-spacer", [_c("span", { staticClass: "body-info-text" })]),
              _vm._v(" "),
              !_vm.$isMobile()
                ? _c(
                    "v-btn",
                    { attrs: { flat: "" }, on: { click: _vm.onExport } },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("get_app"),
                      ]),
                      _vm._v("\n      Exportar\n    "),
                    ]
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$isMobile() && _vm.activeMobileList
        ? _c(
            "AppList",
            _vm._g(_vm._b({}, "AppList", _vm.$attrs, false), _vm.$listeners)
          )
        : _c(
            "AppTable",
            _vm._g(_vm._b({}, "AppTable", _vm.$attrs, false), _vm.$listeners)
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }